import React, { Ref } from 'react';
import * as Tabs from '@radix-ui/react-tabs';
import { cn } from '@/lib/utils/cn';
import styles from './StanTabs.module.css';
import { StanTabContentProps, StanTabProps, StanTabsProps } from './StanTabs.types';

// Main Tabs Container
interface StanTabsPropsWithRef extends StanTabsProps {
    ref?: Ref<HTMLDivElement>;
}

export const StanTabs = ({ children, className, ref, ...props }: StanTabsPropsWithRef) => {
    return (
        <Tabs.Root ref={ref} className={cn(styles.tabsRoot, className)} {...props}>
            {children}
        </Tabs.Root>
    );
};

StanTabs.displayName = 'StanTabs';

// Tab List Container
interface StanTabListProps extends React.HTMLAttributes<HTMLDivElement> {
    ref?: Ref<HTMLDivElement>;
}

export const StanTabList = ({ children, className, ref, ...props }: StanTabListProps) => {
    return (
        <Tabs.List ref={ref} className={cn(styles.tabsList, className)} {...props}>
            {children}
        </Tabs.List>
    );
};

StanTabList.displayName = 'StanTabList';

// Individual Tab
interface StanTabPropsWithRef extends StanTabProps {
    ref?: Ref<HTMLButtonElement>;
}

export const StanTab = ({ children, className, ref, ...props }: StanTabPropsWithRef) => {
    return (
        <Tabs.Trigger
            ref={ref}
            className={cn(styles.tabTrigger, props.disabled && styles.disabled, className)}
            {...props}
        >
            {children}
        </Tabs.Trigger>
    );
};

StanTab.displayName = 'StanTab';

// Tab Content
interface StanTabContentPropsWithRef extends StanTabContentProps {
    ref?: Ref<HTMLDivElement>;
}

export const StanTabContent = ({ children, className, ref, ...props }: StanTabContentPropsWithRef) => {
    return (
        <Tabs.Content ref={ref} className={cn(styles.tabContent, className)} {...props}>
            {children}
        </Tabs.Content>
    );
};

StanTabContent.displayName = 'StanTabContent';
